import { useIntl } from '@capsicum/common';

export const useNCWDepositAddressCHZ = () => {
	const { $t } = useIntl();
	const pageTitle = $t('ncWallet.receive.heading');
	const alertText = $t('ncWallet.receive.depositAddressChz.alertText');

	return {
		intlText: {
			alertText,
			pageTitle
		}
	};
};
